import type { LucideIcon } from "lucide-react";
import { Car, GraduationCap, Home, Plane, Sunset, Wrench } from "lucide-react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import {
	DANGER_MYPLANN_LIGHT,
	GRASS_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

export enum GoalCategory {
	Housing = "Housing",
	Car = "Car",
	Retirement = "Retirement",
	Education = "Education",
	Vacation = "Vacation",
	Custom = "Custom",
}

type GoalCategoryConfig = {
	icon: LucideIcon;
	color: string;
	bgColor: string;
};

export const SELECTABLE_GOAL_CATEGORIES: GoalCategory[] = [
	GoalCategory.Housing,
	GoalCategory.Car,
	GoalCategory.Retirement,
	GoalCategory.Education,
	GoalCategory.Vacation,
	GoalCategory.Custom,
];

export const GOAL_CATEGORY_CONFIG: Record<GoalCategory, GoalCategoryConfig> = {
	[GoalCategory.Housing]: {
		icon: Home,
		color: "#3B82F6",
		bgColor: "#DBEAFE",
	},
	[GoalCategory.Car]: {
		icon: Car,
		color: "#16A34A",
		bgColor: "#DCFCE7",
	},
	[GoalCategory.Retirement]: {
		icon: Sunset,
		color: "#EA580C",
		bgColor: "#FFEDD5",
	},
	[GoalCategory.Education]: {
		icon: GraduationCap,
		color: "#7C3AED",
		bgColor: "#EDE9FE",
	},
	[GoalCategory.Vacation]: {
		icon: Plane,
		color: "#0EA5E9",
		bgColor: "#E0F2FE",
	},
	[GoalCategory.Custom]: {
		icon: Wrench,
		color: "#6B7280",
		bgColor: "#F3F4F6",
	},
};

export type GoalStatus = "on-track" | "warning" | "off-track";

export type GoalContract = {
	id: string;
	name: string;
	value: number;
};

export type Goal = {
	id: string;
	name: string;
	category: GoalCategory;
	status: GoalStatus;
	totalValue: number;
	dueIn: string;
	contracts: GoalContract[];
	completed?: boolean;
};

export const STATUS_STYLE_CONFIG: Record<
	GoalStatus,
	{ color: string; progressColor: string }
> = {
	"on-track": {
		color: GRASS_GREEN_MYPLANN,
		progressColor: GRASS_GREEN_MYPLANN,
	},
	warning: {
		color: "#D97706",
		progressColor: "#F59E0B",
	},
	"off-track": {
		color: DANGER_MYPLANN_LIGHT,
		progressColor: DANGER_MYPLANN_LIGHT,
	},
};

export const STATUS_LABEL_MAP: Record<
	GoalStatus,
	typeof Resources.Goals.List.Status.onTrack
> = {
	"on-track": Resources.Goals.List.Status.onTrack,
	warning: Resources.Goals.List.Status.warning,
	"off-track": Resources.Goals.List.Status.offTrack,
};
